module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADkSURBVEhL7dSxCkFRHMfxK2WzyWDwCGaD0VsIb0J5AJ6AF5CyGFgMiDIrKYtFGZDYiO/fvep0u/eG+y+LX33qP/3+53TqWP/8IhOM7VEvQ0zt0bpjZI96kdKZPT5n9Zil6guikNIVTs4ch1pqkFJTC2rZwb3gCLUs4V6whlrcC24oQCUZmOUiC5VE0IdZfoZKpLwOs1wcEDpJtOEuF6EeN4Uq5JRe5aKLj5JGGT1c4VVqKiEwCRTRhFzXq8SPfHYx+KaDd07pZQB5m8DkUIEskv98gS32jtfyCzaYo4E8/vk2lvUA941zYrNtsjgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-slug/dark/24.png
// module id = 2436
// module chunks = 2